import React, {useEffect, useState, useContext} from 'react';
import classnames from 'classnames';
import {Input, Spin, Alert} from 'antd';
import {includes, get} from 'lodash';
import {useRouteMatch} from 'react-router-dom';
import {AppContext} from '../state';
import {ExclamationCircleTwoTone} from '@ant-design/icons';
import {OpenApiContext} from '../openapi-context';
import {errorsForModel, errorsForInterface} from '../utils/openapi-schema-validator';

export function LintView({className, spec, type, intKey, modelKey, currentHash}) {
    const classes = classnames(className, 'editor');
    const {backend} = useContext(AppContext);
    const openapiContext = useContext(OpenApiContext);
    const {params} = useRouteMatch('/:env/standards/:category/:key/:version');
    const [lintResult, setLintResult] = useState('');
    const [filter, setFilter] = useState();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function loadLintMessages() {
            const messages = [];
            try {
                setIsLoading(true);
                if (openapiContext.state.specValidationErrors) {
                    if (type === 'models') {
                        messages.push(
                            ...errorsForModel(openapiContext.state.specValidationErrors, modelKey).map((msg) => {
                                return {
                                    type: 'schema',
                                    error: msg,
                                };
                            })
                        );
                    } else if (type === 'interface') {
                        messages.push(
                            ...errorsForInterface(openapiContext.state.specValidationErrors, intKey).map((msg) => {
                                return {
                                    type: 'schema',
                                    error: msg,
                                };
                            })
                        );
                    }
                }

                if (type === 'interface') {
                    const data = await backend.lintInterface(params.category, params.key, params.version, intKey);
                    messages.push(...(get(data, 'warnings') || []));
                } else if (type === 'models') {
                    const data = await backend.lintModel(params.category, params.key, params.version, modelKey);
                    messages.push(...(get(data, 'warnings') || []));
                } else {
                    const data = await backend.lintChanges(params.category, params.key, params.version);
                    messages.push(...(get(data, 'warnings') || []));
                }

                setLintResult(messages);
            } catch (err) {
            } finally {
                setIsLoading(false);
            }
        }
        loadLintMessages();
    }, [spec, type, intKey, modelKey, currentHash]);

    function filteredResult() {
        if (filter) {
            return lintResult.filter((o) => includes(o.rule.description.toLowerCase(), filter.toLowerCase()));
        } else {
            return lintResult;
        }
    }

    const LoaderView = () => {
        return <div>{isLoading ? <Spin size="large" /> : <Alert showIcon title="No error found" type="success" />}</div>;
    };

    return lintResult.length > 0 ? (
        <div className={classes}>
            <div className="scrollable">
                <div className="searchFilter">
                    <Input.Search placeholder="filter results..." className="lintFilter" onChange={(value) => setFilter(value.target.value)} allowClear={true} />
                </div>
                <table style={{width: '100%', border: '1px solid lightgrey'}}>
                    <tbody>
                        <tr style={{borderBottom: '1px solid lightgrey'}}>
                            <th className="lintRow" style={{width: '10%'}}>
                                Type
                            </th>
                            <th className="lintRow" style={{width: '50%'}}>
                                Message
                            </th>
                            <th className="lintRow" style={{width: '40%'}}>
                                Datapath
                            </th>
                        </tr>
                        {filteredResult().map((item, key) => {
                            if (item.type === 'schema') {
                                return (
                                    <tr key={key}>
                                        <td className="lintData">
                                            <ExclamationCircleTwoTone twoToneColor="red" />
                                        </td>
                                        <td className="lintData">
                                            {item.error.message}
                                            <p>{JSON.stringify(item.error.params)}</p>
                                        </td>
                                        <td className="lintData">{item.error.instancePath}</td>
                                    </tr>
                                );
                            } else {
                                return (
                                    <tr key={key} style={{borderBottom: '1px solid lightgrey'}}>
                                        <td className="lintData">
                                            <ExclamationCircleTwoTone twoToneColor="orange" />
                                        </td>
                                        <td className="lintData">{item.rule.description || 'unspecified'}</td>
                                        <td className="lintData">{item.dataPath || 'unspecified'}</td>
                                    </tr>
                                );
                            }
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    ) : (
        <LoaderView />
    );
}
